module.exports = __webpack_public_path__ + "img/BULLDOZER.eb2ce0cd.svg";